const CryptoJS = require('crypto-js')

const base = {
    aesEncrypt(text) {
        const key = CryptoJS.enc.Utf8.parse("nixiangsiquanjia");
        const encrypted = CryptoJS.AES.encrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }
}

export default base
